module Meevo.Plugins.WaitList {
    export enum WaitListClientChangedPromptEditOptionEnum {
        EditExpired,
        EditActive
    }

    export enum WaitListClientChangedPromptResponseEnum {
        Edit,
        Replace
    }

    class WaitListClientChangedPromptController {
        private editButtonContentKey: string;
        private replaceButtonContentKey: string;
        private headerContentKey: string;

        static $inject = [
            "meevo.components.modal.ModalService", "$mdDialog", "editOption","appointmentRequest", "client"
        ];

        constructor(private modalService: Meevo.Components.Modal.IModalService, private $mdDialog,
            private editOption: WaitListClientChangedPromptEditOptionEnum, private appointmentRequest,
            private client: Model.ClientListItem) {
            this.editButtonContentKey = "LABEL_EDIT";
            this.replaceButtonContentKey = "LABEL_REPLACE";
            this.headerContentKey = "HEADER_CONFIRM";
        }

        getHeader() {
            let services = _(this.appointmentRequest.services).chain().where({ clientId: this.client.id })
                .map(service => service.serviceDisplayName).value();
            
            return `${this.client.displayName} currently has an
${this.editOption == WaitListClientChangedPromptEditOptionEnum.EditExpired ? "expired" : "active"}
 appointment request for ${services.join(", ")}.  Do you want to continue or edit existing?` ;
        }

        edit() {
            this.$mdDialog.hide({
                response: WaitListClientChangedPromptResponseEnum.Edit,
                option: this.editOption,
                id: this.appointmentRequest.id
            });
        }

        continue() {
            this.$mdDialog.hide({
                response: WaitListClientChangedPromptResponseEnum.Replace,
                option: this.editOption,
                id: this.appointmentRequest.id
            });
        }
    }
    angular.module("meevo.plugins.waitList")
        .controller("meevo.plugins.waitList.WaitListClientChangedPromptController", WaitListClientChangedPromptController);
}